import { CourseAssignmentStatus } from '../../../../api/types/programs/course/assignments/course-assignment-status';

export const getAssignmentStatusText = (
  assignmentStatus: CourseAssignmentStatus,
): string => {
  switch (assignmentStatus) {
    case CourseAssignmentStatus.CLOSE_TO_SUBMIT:
      return 'סגור להגשה';
    case CourseAssignmentStatus.OPEN_TO_SUBMIT:
      return 'פתוח להגשה';
  }
};
